<div class="compact-stepper" [matTooltip]="label()" [matTooltipDisabled]="noTooltip()">
    @if (icon()) {
        <img class="stepper-icon" [src]="src()" [alt]="label()">
    }
    <button type="button" class="stepper-btn" [disabled]="!canDecrement()"
            [attr.aria-label]="'-'" (click)="decrement()">
        <mat-icon>remove</mat-icon>
    </button>
    <span class="stepper-value">{{ display() }}</span>
    <button type="button" class="stepper-btn" [disabled]="!canIncrement()"
            [attr.aria-label]="'+'" (click)="increment()">
        <mat-icon>add</mat-icon>
    </button>
</div>
